import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { contactDeveloper, MyLog } from '@common/common';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { UserDeviceService } from '@services/user-device.service';
import { tryToScrollDown } from '@util/visual-utils';
import { Subscription } from 'rxjs';
import SignaturePad from '../../../sigpad/signature_pad';
import { clearPad, resizeCanvas } from '../../../sigpad/sigpad_util';
import { FillAgbDialogComponent } from '../fill-agb-dialog/fill-agb-dialog.component';
import { setByDialogHeight } from '../../order-dialog.helper';
import { SpecialDocumentBase } from '../../special-document-base';
import { OrderDialogService } from '../../order-dialog.service';
import { isFunction, isJsObject } from '@util/utils';
import { updateCanvasSize } from '../../../image-edit/image-edit-util';
import { getClientRect } from '@util/web-utils';

function po(left: string, top: string) {
  return { left: left, top: top };
}

const resultTopOffset = '10.65cm';
const montageTypeOffset = '9.4cm';
const pictureTopOffset = '17.4cm';

@Component({
  selector: 'app-fill-report-dialog',
  templateUrl: './fill-report-dialog.component.html'
})
export class FillReportDialogComponent extends SpecialDocumentBase implements OnInit {
  resultStyleOK = po('10.6cm', resultTopOffset);
  resultStyleNotOK = po('13.8cm', resultTopOffset);
  montageTypeRepair = po('5cm', montageTypeOffset);
  montageTypeReplace = po('13.8cm', montageTypeOffset);
  pictureYes = po('2.85cm', pictureTopOffset);
  pictureNo = po('5.35cm', pictureTopOffset);

  damageStyle: any = {};
  damageCanvasStyle: any = {};

  signCustomerStyle: any = {};
  signCustomerCanvasStyle: any = {};

  signMontageStyle: any = {};
  signMontageCanvasStyle: any = {};

  content = '';
  signUrl = '';

  montageType = 2;
  workResult = 0;
  commentType = 1;
  pictureResult = 0;

  customCls = '';// 'document-scroll';

  deviceSub!: Subscription;

  signaturePadDamageNote: SignaturePad | null = null;

  signaturePadDamage: SignaturePad | null = null;

  signaturePadCustomerSign: SignaturePad | null = null;

  signaturePadMontageSign: SignaturePad | null = null;

  private _damageNoteText?: ElementRef;
  @ViewChild('damageNoteText') set damageNoteText(elem: ElementRef) {
    this._damageNoteText = elem;
  }

  private _canvasDamageNote?: ElementRef;
  @ViewChild('damageNote') set damageNote(elem: ElementRef) {
    this._canvasDamageNote = elem;
    this.signaturePadDamageNote = updateCanvasSize(elem, {
      maxWidth: 1.5
    });
  }

  private _canvasDamage?: ElementRef;
  @ViewChild('canvasDamage') set canvasDamage(elem: ElementRef) {
    this._canvasDamage = elem;
    this.signaturePadDamage = updateCanvasSize(elem, {
      penColor: '#FF0000'
    });
  }

  private _signatureCanvasCustomer?: ElementRef;
  @ViewChild('signCanvasCustomer') set signPadCustomer(elem: ElementRef) {
    this._signatureCanvasMontage = elem;
    this.signaturePadCustomerSign = updateCanvasSize(elem);
  }

  private _signatureCanvasMontage?: ElementRef;
  @ViewChild('signCanvas') set signPad(elem: ElementRef) {
    this._signatureCanvasMontage = elem;
    this.signaturePadMontageSign = updateCanvasSize(elem);
  }

  private _cnt?: ElementRef;
  @ViewChild('cnt') set contentRef(content: ElementRef) {
    this._cnt = content;
    setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
  }

  changeType(type: number) {
    this.montageType = type;
  }

  changeWorkResult(res: number) {
    this.workResult = res;
  }

  changePictureResult(res: number) {
    this.pictureResult = res;
  }

  changeCommentType(type: number) {
    this.commentType = type;
  }

  constructor(
    public dialogRef: MatDialogRef<FillAgbDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    notificationService: NotificationService,
    private dataService: DataService,
    private userDeviceService: UserDeviceService,
    dialogService: OrderDialogService
  ) {
    super(notificationService);
    this.setDefaultPositions(dialogService);
  }

  setDefaultPositions(dialogService: OrderDialogService) {

    const dialogStyle = dialogService.getStylesForDialog('report', {});

    if (!isJsObject(dialogStyle)) {
      MyLog.error('Failed to get style');
      return;
    }

    this.resultStyleOK = dialogStyle?.resultOK || this.resultStyleOK;
    this.resultStyleNotOK = dialogStyle?.resultNotOK || this.resultStyleNotOK;
    this.montageTypeRepair = dialogStyle?.montageTypeRepair || this.montageTypeRepair;
    this.montageTypeReplace = dialogStyle?.montageTypeReplace || this.montageTypeReplace;
    this.pictureYes = dialogStyle?.pictureYes || this.pictureYes;
    this.pictureNo = dialogStyle?.pictureNo || this.pictureNo;

    let style = dialogStyle.damage;

    if (style) {
      this.damageStyle = style?.pos || this.damageStyle;
      this.damageCanvasStyle = style?.canvas || this.damageCanvasStyle;
    }

    style = dialogStyle.customerSignature;
    if (style) {
      this.signCustomerStyle = style?.pos || this.signCustomerStyle;
      this.signCustomerCanvasStyle = style?.canvas || this.signCustomerCanvasStyle;
    }

    style = dialogStyle.montageSignature;
    if (style) {
      this.signMontageStyle = style?.pos || this.signMontageStyle;
      this.signMontageCanvasStyle = style?.canvas || this.signMontageCanvasStyle;
    }
  }

  ngOnInit(): void {
    const prefix = '/montage/documents/' + this.dialogData.orderId;
    this.signUrl = prefix + '/report/sign';
    this.editUrl = prefix + '/report/edit';

    this.deviceSub = this.userDeviceService.change().subscribe((ev: any) => {
      const toResize: any[][] = [
        [this._canvasDamageNote, this.signaturePadDamageNote],
        [this._canvasDamage, this.signaturePadDamage],
        [this._signatureCanvasCustomer, this.signaturePadCustomerSign],
        [this._signatureCanvasMontage, this.signaturePadMontageSign],
      ];

      for (let e of toResize) {
        const elem = e[0];
        elem && resizeCanvas(elem.nativeElement, e[1]);
      }

      setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
    });

    this.requestEditData(
      this.editUrl,
      this.dataService,
      this.notificationService,
      'Problem beim Laden der Daten für Abnahmeprotokoll'
    );
  }

  ngOnDestroy(): void {
    this.deviceSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    tryToScrollDown(this._cnt?.nativeElement);
  }

  getDamageText() {
    const res: any = {};

    if (this.commentType === 1) {
      const ref = this._damageNoteText?.nativeElement;
      if (ref) {
        let text = ref.value || '';
        text = text.trim();

        if (text.length) {
          res.damage_text = text;
        }
      } else {
        res.error = 'Problem beim Erfassen der Mängel. ' + contactDeveloper;
      }
    } else {
      let p = this.signaturePadDamageNote;
      res.damage_text_free = '';

      if (p) {
        if (p.isEmpty()) {
          res.error = 'Bitte Mängel angeben.';
        } else {
          res.damage_text_free = p.toDataURL();
        }
      } else {
        res.error = 'Problem beim Erfassen der Mängel. ' + contactDeveloper;
      }

    }
    return res;
  }

  prepareRequest() {
    const errors: any[] = [];

    const reqData: any = {};

    reqData.work_type = this.montageType;

    if ([1, 2].indexOf(this.workResult) >= 0) {
      reqData.work_result = this.workResult;

      const damageRes = this.getDamageText();

      if (this.workResult === 2) {

        if (damageRes.error) {
          errors.push(damageRes.error);
        } else {
          let err = 'Bitte Mängel angeben';
          if (this.commentType === 1) {
            if (damageRes.damage_text) {
              reqData.damage_text = damageRes.damage_text;
              err = ''
            }
          } else {
            if (damageRes.damage_text_free) {
              reqData.damage_text_free = damageRes.damage_text_free;
              err = '';
            }
          }
          err && errors.push(err);
        }
      } else {
        if (this.commentType === 1 && damageRes.damage_text) {
          reqData.damage_text = damageRes.damage_text;
        }
        if (this.commentType === 2 && damageRes.damage_text_free) {
          reqData.damage_text_free = damageRes.damage_text_free;
        }
      }
    } else {
      errors.push('Wurde die Arbeit ordnungsgemäß ausgeführt ?');
    }

    let p: SignaturePad | null;

    if ([1, 2].indexOf(this.pictureResult) >= 0) {
      reqData.picture_result = this.pictureResult;
      if (reqData.picture_result === 1) {

      }
      p = this.signaturePadDamage;
      if (p) {
        if (!p.isEmpty()) {
          reqData.damage = p.toDataURL();
        }
      }
    } else {
      errors.push('Sind Bilder vor Scheibenausbau vorhanden ?');
    }

    p = this.signaturePadCustomerSign;

    if (p) {
      if (p.isEmpty()) {
        errors.push('Unterschrift des Kunden nicht gesetzt');
      } else {
        const data = p.toDataURL(); // save image as PNG
        reqData.customer_signature = data;
      }
    } else {
      errors.push('Problem beim Erfassen der Kundenunterschrift. ' + contactDeveloper);
    }

    p = this.signaturePadMontageSign;

    if (p) {
      if (p.isEmpty()) {
        errors.push('Unterschrift des Montageleiters nicht gesetzt');
      } else {
        const data = p.toDataURL();
        reqData.montage_signature = data;
      }
    } else {
      errors.push('Problem beim Erfassen der Unterschrift des Montageleiters. ' + contactDeveloper);
    }

    return {
      data: reqData,
      errors
    };
  }

  signClose(save: boolean) {

    if (save) {

      const req = this.prepareRequest();

      if (req.errors.length) {
        this.notificationService.showErrors(req.errors);
        return;
      }
      this.dataService.post(this.signUrl, req.data, {}).subscribe((res: any) => {
        const data = res?.result;
        if (data.success) {
          this.notificationService.showSuccess(
            'Abnahmeprotokoll gespeichert'
          );
          this.dialogRef.close(data);
        } else {
          let errors: any[] = [];
          if (Array.isArray(data?.errors)) {
            errors = data.errors;
          } else {
            errors.push(
              data?.error || 'Unbekannter Fehler beim Speichern'
            );
          }

          this.notificationService.showErrors(errors);
        }
      });
      return;
    }
    this.dialogRef.close(null);
  }

  readonly CUSTOMER = 'customer_sign';
  readonly DAMAGE = 'damage';
  readonly DAMAGE_NOTE = 'damage_note';
  readonly MONTAGE = 'montage_sign';

  clear(type: string) {
    switch (type) {
      case this.CUSTOMER:
        clearPad(this.signaturePadCustomerSign);
        return;
      case this.DAMAGE:
        clearPad(this.signaturePadDamage);
        return;
      case this.DAMAGE_NOTE:
        clearPad(this.signaturePadDamageNote);
        return;
      case this.MONTAGE:
        clearPad(this.signaturePadMontageSign);
        return;
    }
  }
  elementIds = ['report_top', 'report_middle', 'report_down'];

  scrollTop(idx: number) {
    var elId = this.elementIds[idx];

    var el = document.getElementById(elId);
    var contentEl = document.getElementById('report_content');

    if (el && contentEl) {
      //const elRect = getClientRect(el);
      //console.log('RECT:', elRect, isFunction(contentEl.scrollTo));
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}
